import {INIT_AVAIL, INIT_BOOKING_CONTEXT} from "../data";

export const state = {
    avail: INIT_AVAIL,
    context: INIT_BOOKING_CONTEXT
};